// ----------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code
// EDIT THE CORRESPONDENT .ts FILE INSTEAD

export const accountCacheIdentifier = (exchangeId, exchangeInstanceId) => `account-${exchangeId}`;
export const marketsByIdCacheIdentifier = (exchangeId) => `marketsById-${exchangeId}`;
export const marketsCacheIdentifier = (exchangeId) => `markets-${exchangeId}`;
export const symbolsCacheIdentifier = (exchangeId) => `symbols-${exchangeId}`;
export const idsCacheIdentifier = (exchangeId) => `ids-${exchangeId}`;
export const currenciesCacheIdentifier = (exchange) => `currencies-${exchange.id}${["binance", "bybit", "mexc", "okx"].includes(exchange.id) ? `-${exchange.exchangeInstanceId}` : ""}`;
export const currenciesByIdCacheIdentifier = (exchange) => `currenciesById-${exchange.id}${["binance", "bybit", "mexc", "okx"].includes(exchange.id) ? `-${exchange.exchangeInstanceId}` : ""}`;
export const networkIdsByCurrencyAndNetworkCodesCacheIdentifier = (exchangeId) => `networkIdsByCurrencyAndNetworkCodes-${exchangeId}`;
export const currencyIdsByCodeAndNetworkCodeCacheIdentifier = (exchangeId) => `currencyIdsByCodeAndNetworkCode-${exchangeId}`;
export const chainIdbyEcidsCacheIdentifier = (exchangeId) => `chainIdbyEcids-${exchangeId}`;
export const ecidByChainIdsCacheIdentifier = (exchangeId) => `ecidByChainIds-${exchangeId}`;
export const currenciesForWithdrawalCacheIdentifier = (exchangeId) => `currenciesForWithdrawal-${exchangeId}`;
export const accountsCacheIdentifier = (exchangeId, exchangeInstanceId) => `accounts-${exchangeId}-${exchangeInstanceId}`;
export const timeDifferenceCacheIdentifier = (exchangeId) => `timeDifference-${exchangeId}`;
export const PUBLIC_DATA_CACHE_TTL = 1000 * 60 * 60 * 24; // 1 day
export const PRIVATE_DATA_CACHE_TTL = 1000 * 60 * 30; // 30 minutes
export const ACCOUNTS_DATA_CACHE_TTL = 1000 * 60 * 5; // 5 minutes
export const currenciesCacheTTL = (exchange) => {
    if (["binance", "bybit", "mexc", "okx"].includes(exchange.id)) {
        return PRIVATE_DATA_CACHE_TTL; // 30 minutes
    }
    if (exchange.id === "htx") {
        return 1000 * 60 * 30; // 30 minutes (because we need to have the network fees updated)
    }
    return PUBLIC_DATA_CACHE_TTL; // 1 day
};
